<div id="academy-course" class="divback page-layout simple left-sidebar inner-scroll">
<div class="center" fxLayout="column">
  <!-- <toolbar></toolbar> -->
  <div class="" fxLayout="row" fxLayoutAlign="space-between start">
    <div class="imagenEmpresa" fxLayout="column" fxLayoutAlign="space-between center">
      <img src="./assets\images\logos/logo.gif" alt="">
    </div>
    <div class="" fxLayout="column" fxLayoutAlign="space-between center">
      <h1>Empresa Demo</h1>
    </div>
    <div class="imagenInstituto" fxLayout="column" fxLayoutAlign="space-between center">
      <img src="./assets\images\logos/gptw.jpg" alt="">
    </div>

  </div>

  <div *ngIf="cambioSecciones>=2"class="" fxLayout="row" fxLayoutAlign="space-between start">

    <div class="botonInstruciones" fxLayout="column" fxLayoutAlign="space-between center" >
    <div class="fondo">
    <button mat-button class="botonLetra" (click)="openDialog()"><mat-icon>error_outline</mat-icon>Intrucciones</button>
    </div>
    </div>

    <div class="botonInstruciones" fxLayout="column" fxLayoutAlign="space-between center">
    <div class="fondo" fxLayout="column" fxLayoutAlign="space-between center">
     <button mat-button class="botonLetra" (click)="openDialogDefiniciones()"><mat-icon>error_outline</mat-icon>Definiciones</button>
    </div>
    </div>

  </div>

<div *ngIf="cambioSecciones==0" class="videoBienvenida" fxLayout="column" fxLayoutAlign="center center" >
<div class="" fxLayout="row" fxLayoutAlign="center center">
<h1>Intro Bienvenida</h1>
</div>

<div class="" fxLayout="row" fxLayoutAlign="center center" >
  <iframe src="http://www.youtube.com/embed/wzrnuUOoFNM?rel=0&amp;autoplay=1" frameborder="0" allowfullscreen fxFlex.lt-sm="80%"></iframe>
</div>
</div>

<div *ngIf="cambioSecciones==1" class="IntroBienvenida" fxLayout="row" fxLayoutAlign="center center" >
  <div class="Infoencuesta" fxLayout="column">
    <h1>Información de la encuesta</h1>

  <span>Fuiste seleccionado para participar en una encuesta de clima organizacional que el Instituto Great Place to Work® está aplicando para FS-MEXICO.
    <br>
    <span>Tu participación es muy importante para el éxito de este estudio, toma en consideración lo siguiente:</span>
    <br>
    <span>• Tardarás aproximadamente 10 minutos en contestar la encuesta.  </span>
    <br>
    <span>• Transcurrido este tiempo, si no has terminado, te pedimos cerrar y reabrir tu encuesta.  </span>
    <br>
    <span>• Por favor, no uses los botones del navegador de internet, usa sólo los de la encuesta, que se encuentran al final de cada página.</span>
  </span>
     <br>
      <span>Tus respuestas nos ayudarán a describir cómo es el ambiente laboral en FS-MEXICO.
        <br>
        <span>Esto nos permitirá conocer los puntos en los que deberán trabajar en conjunto para mejorar.</span></span>
       <br>
      <span>Responde con toda sinceridad. No hay respuestas correctas o incorrectas. Ninguna empresa es perfecta, cada una tiene cosas buenas y a mejorar.
       <br>
      <span>El cuestionario está compuesto de preguntas que tienen 2 conjuntos de respuestas; es decir, cuando contestes cada pregunta por favor piensa en:</span>
       <br>
      <span>(1) la empresa como un todo y en los jefes en general, desde tu jefe directo hasta el Director General.</span>
       <br>
      <span>(2) el área o departamento al que perteneces y tu jefe directo.</span></span>
     <br>

      <span>No ingreses ni tu nombre ni tu firma: Todo aquello que expreses en este cuestionario será confidencial. Tus respuestas no las conocerá nadie de tu empresa y serán resguardadas confidencialmente en el servidor de Great Place to Work®. Las respuestas participantes serán procesadas estadísticamente y computarizadas en conjunto para conocer el sentimiento general de TODOS, y no el de cada uno en particular.
       <br>
    <span>El valor final de esta encuesta de opinión será resultado de la sinceridad, veracidad y objetividad contenidas en todas las respuestas. Por ello, es recomendable que leas con atención cada una de las preguntas de este cuestionario y procures contestar a cada una de ellas expresando tus sentimientos reales.</span></span>

      <h3>Muchas gracias por tu participación.</h3>

        <span>Siempre puedes confiar en Great Place to Work, si deseas compartir alguna anomalía comunícate al 01 800- 5068338 o escríbenos un correo a:
        <span>mx_transparencia@greatplacetowork.com  </span></span>
  </div>
</div>




  <barra-progreso *ngIf="cambioSecciones==2"></barra-progreso>
  <reactivos fusePerfectScrollbar *ngIf="cambioSecciones==2"></reactivos>
  <nps fusePerfectScrollbar *ngIf="cambioSecciones==3"></nps>
  <for-all  fusePerfectScrollbar *ngIf="cambioSecciones==4"></for-all>
  <demograficos fusePerfectScrollbar *ngIf="cambioSecciones==5"></demograficos>

<div class=""fxLayout="row" fxLayoutAlign="center center">

      <div *ngIf="cambioSecciones>=1" fxLayout="column" fxLayoutAlign="center center" >
      <button class="botonAnterior" type="button" name="Siguiente" (click)="anteriorSeccion()">Anterior</button>
      </div>
        <div fxLayout="column" fxLayoutAlign="center center" >
          <button class="botonSiguiente" type="button" name="Siguiente" (click)="siguienteSeccion()">Siguiente</button>
        </div>
      </div>
  </div>
</div>
